import { useCallback } from "react"
import { toast } from "sonner"
import { useLocale } from "@holigral/shared/routing"
import openAuth from "./openAuth"
import type { SocialProvider } from "./model"
import { useConnectOauthMutation } from "./api"
import { useTokenRefreshMutation } from "@/base/baseApi"
import { useT } from "@/i18n"

export default () => {
  const { t } = useT("auth")
  const locale = useLocale()
  const [connect, { isLoading: isConnecting }] = useConnectOauthMutation()
  const [tokenRefresh] = useTokenRefreshMutation()

  const handleConnect = useCallback(
    (provider: SocialProvider) => {
      openAuth(
        async () => {
          const { authUrl } = await connect({ provider, locale }).unwrap()

          return authUrl
        },
        async (result) => {
          switch (result.result) {
            case "success":
              await tokenRefresh(result.refreshToken).unwrap()

              return
            case "cancelled":
              return
            case "error":
              toast.error(result.error || t("socialError"))

              return
          }
        },
      )
    },
    [connect, tokenRefresh, t, locale],
  )

  return { handleConnect, isConnecting }
}
